import React from "react";
import { Link } from "react-router-dom";
import { BookIcon, GearIcon, PuzzleIcon } from "./icons";
import { ChevronRightIcon, CodeIcon } from "../Auth/onboarding/icons";
import { RoutesPaths } from "../../Router/constant";

const actions = [
  {
    icon: <BookIcon />,
    title: "Train your knowledge",
    detail: "Add files, pages or FAQs",
    redirection: RoutesPaths?.TRAINING_BOT,
  },
  {
    icon: <GearIcon />,
    title: "Customize your assistant",
    detail: "Change tone, behavior and more",
    redirection: RoutesPaths?.CUSTOMIZATION,
  },
  {
    icon: <PuzzleIcon />,
    title: "Integrations",
    detail: "Connect your calendar, CRM and helpdesk",
    redirection: RoutesPaths?.INTEGRATIONS,
  },
  {
    icon: <CodeIcon />,
    title: "Installation settings",
    detail: "Update your embed code & domains",
    redirection: RoutesPaths?.INSTALL_SETTINGS,
  },
];

export default function QuickActions() {
  return (
    <section className="dash-card">
      <div className="dash-card-header">
        <h2 className="dash-card-title">Quick actions</h2>
      </div>

      <ul className="dash-quick-actions">
        {actions.map((action) => (
          <li key={action.title}>
            <Link to={action.redirection} className="dash-quick-action">
              <span className="dash-quick-action-icon">{action.icon}</span>
              <span className="dash-quick-action-text">
                <strong>{action.title}</strong>
                <span>{action.detail}</span>
              </span>
              <ChevronRightIcon />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
